import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonModule, ButtonOptions } from '@usitsdasdesign/dds-ng/button';
import { DropdownItemOptions, DropdownModule, DropdownOptions } from '@usitsdasdesign/dds-ng/dropdown';
import { ExtThemes, ButtonKind, Size, WidthState } from '@usitsdasdesign/dds-ng/shared';
import { TabsModule } from '@usitsdasdesign/dds-ng/tabs';
import { Service } from '../../core/models/service.models';
import { ServicesService } from '../../core/services/services.service';
import { getServiceLabel } from '../../core/utils/label.utils';

@Component({
  selector: 'app-project-services',
  standalone: true,
  imports: [ButtonModule, TabsModule, DropdownModule, RouterModule],
  templateUrl: './project-services.component.html',
  styleUrl: './project-services.component.scss',
})
export class ProjectServicesComponent implements OnInit {
  projectId: string;
  services: Service[];
  serviceId: string;

  constructor(private route: ActivatedRoute, private router: Router, private servicesService: ServicesService) {}

  dropdownOptions: DropdownOptions = {
    label: 'No services available',
    ariaLabel: '',
    theme: ExtThemes.dark,
    kind: ButtonKind.primary,
    size: Size.md,
    width: WidthState.fixed,
    isColorBg: false,
    isInverse: false,
    customClass: '',
    disabled: true,
    isResponsive: false,
    stickerIsOutsideClick: false,
    stickerShift: 0,
    stickerMaxHeight: '',
    stickerIsDisabled: false,
    stickerPosition: 'bottom-left',
    stickerIndent: 0,
    stickerCustomClass: '',
    stickerIsDynamic: true,
  };

  dropdownItems: DropdownItemOptions[];

  itemSelected(value: string) {
    this.serviceId = value;
  }

  get currentService(): Service | undefined {
    return this.services?.find((s) => s.id === this.serviceId);
  }

  createServiceButtonOptions: ButtonOptions = {
    theme: ExtThemes.green,
    kind: ButtonKind.primaryLoud,
    size: Size.md,
    width: WidthState.fixed,
    isLoading: false,
    icon: 'dds-icon_plus',
    isIconLeft: false,
    isColorBg: false,
    isInverse: false,
    disabled: false,
    ariaLabel: 'Create a new Service',
    customClass: '',
    role: 'button',
  };

  createServiceClick(): void {
    this.router.navigate(['create-service'], { relativeTo: this.route.parent });
  }

  editServiceButtonOptions: ButtonOptions = {
    theme: ExtThemes.green,
    kind: ButtonKind.primary,
    size: Size.md,
    width: WidthState.fixed,
    isLoading: false,
    icon: 'dds-icon_edit',
    isIconLeft: false,
    isColorBg: false,
    isInverse: false,
    disabled: false,
    ariaLabel: 'Edit service',
    customClass: '',
    role: 'button',
  };

  editServiceClick(): void {
    if (this.serviceId) {
      this.router.navigate(['edit-service', this.serviceId], { relativeTo: this.route.parent });
    }
  }

  copyButtonOptions: ButtonOptions = {
    theme: ExtThemes.green,
    kind: ButtonKind.primaryLoud,
    size: Size.lg,
    width: WidthState.fixed,
    isLoading: false,
    icon: 'dds-icon_copy',
    isIconLeft: false,
    isColorBg: false,
    isInverse: false,
    disabled: false,
    ariaLabel: 'Copy',
    customClass: '',
    role: 'button',
  };

  copyClick(): void {
    if (this.serviceId) {
      navigator.clipboard.writeText(this.serviceId);
    }
  }

  viewApiSpecificatioClick(): void {
    this.router.navigate(['api-specifications'], { relativeTo: this.route.parent });
  }

  ngOnInit(): void {
    this.services = [];
    this.dropdownItems = [];

    this.route.parent?.paramMap.subscribe((params) => {
      this.projectId = params.get('id') ?? '';

      this.servicesService.getServicesForProject(this.projectId).subscribe((response) => {
        this.services = response == null ? [] : response;
        this.serviceId = this.services.length > 0 ? this.services[0].id : '';
        this.populateDropdown();

        // Redirect to create service page if no services exist
        if (this.services.length === 0) {
          this.router.navigate(['create-service'], { relativeTo: this.route.parent });
        }
      });
    });
  }

  private populateDropdown(): void {
    if (this.services.length > 0) {
      this.dropdownOptions.label = getServiceLabel(this.services[0]);
      this.dropdownOptions.disabled = false;

      for (let service of this.services) {
        this.dropdownItems.push({
          heading: getServiceLabel(service),
          value: service.id,
        });
      }
    } else {
      this.dropdownOptions.label = 'No services available';
      this.dropdownOptions.disabled = true;
    }
  }
}
